import React, {Component} from 'react';
import ReactDomServer from 'react-dom/server';
import {Marker} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {inject} from 'mobx-react';
import centerOfMass from '@turf/center-of-mass'
import PropTypes from 'prop-types';

@inject('mapStore')
class IconMarker extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.id) {

      const feature = this.props.mapStore.geoJsonFeatures.find((feature) => {
        return (feature.properties.id === this.props.id);
      });

      if (feature && parseInt(feature.properties.floor) === this.props.mapStore.floor) {
        const center = centerOfMass(feature);
        const icon = L.divIcon({
          className: `marker ${this.props.classNames}`,
          html: ReactDomServer.renderToStaticMarkup(
            <React.Fragment>
              <img src={this.props.iconUrl} alt=""/>
              {this.props.children}
            </React.Fragment>
          ),
          iconSize: [30, 30],
          iconAnchor: [15, 15]
        });
        return <Marker key={`marker-${this.props.id}`} position={[center.geometry.coordinates[1], center.geometry.coordinates[0]]} icon={icon}></Marker>
      } else {
        return null;
      }

    }
  }
}

IconMarker.propTypes = {
  id: PropTypes.string,
  classNames: PropTypes.string,
  iconUrl: PropTypes.string
};

export default IconMarker;




